<template>
  <div id="contenedor-informacion-proyecto-documento">
    <v-card>
      <v-card-title class="secondary--text">
        Información
        <v-spacer></v-spacer>
        <v-btn icon @click="cerrar">
          <v-icon class="secondary--text" large>highlight_off</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-row>
          <h3>{{ proyectoDocumento.proyectoDocumentoTipo.descripcion }}</h3>
        </v-row>
        <v-row>
          <span>{{ proyectoDocumento.descripcion }}</span>
        </v-row>
        <v-row>
          <span>
            Fecha Documento: {{ $moment(proyectoDocumento.fecha).format("DD/MM/YYYY") }}
          </span>
        </v-row>
        <v-row justify="center" align="center">
          <v-col cols="1" class="mr-4">
            <v-row justify="start">
              <v-icon x-large>
                {{ $iconoDeExtension(proyectoDocumento.datosArchivo.extension) }}
              </v-icon>
            </v-row>
          </v-col>
          <v-col cols="10">
            <v-row align="center">
              <span
                >Tamaño de archivo: {{ $humanFileSize(proyectoDocumento.datosArchivo.size) }}
              </span>
            </v-row>
            <v-row align="center">
              <span>Formato: {{ proyectoDocumento.datosArchivo.extension }} </span>
            </v-row>
            <v-row align="center">
              <span>
                Fecha de carga:
                {{
                  $moment(proyectoDocumento.datosArchivo.createdAt).format("DD/MM/YYYY - h:mm:ss a")
                }}
              </span>
            </v-row>
          </v-col>
        </v-row>
        <v-row>
          Registrado por:
        </v-row>
        <v-row align="center">
          <v-col cols="2">
            <v-avatar color="base6" size="50">
              <h2 class="white--text">
                {{ $inicialesNombre(proyectoDocumento.usuarioRegistro.funcionario.nombre) }}
              </h2>
            </v-avatar>
          </v-col>
          <v-col>
            <v-row>{{ proyectoDocumento.usuarioRegistro.funcionario.nombre }}</v-row>
            <v-row>{{ proyectoDocumento.usuarioRegistro.funcionario.puesto }}</v-row>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'InformacionProyectoDocumento',
  props: {
    proyectoDocumento: {
      type: Object,
      required: true,
    },
  },
  methods: {
    cerrar() {
      this.$emit('cerrar');
    },
  },
};
</script>

<style lang="scss" scoped></style>
